import { render, staticRenderFns } from "./share_model_carriers.vue?vue&type=template&id=3b2befa2&"
import script from "./share_model_carriers.vue?vue&type=script&lang=js&"
export * from "./share_model_carriers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports